import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks/hooks'
import { selectCurrent } from '../../redux/settings/selectors'
import { settings } from '../../redux/settings/actions'
import { DeleteModal } from '../../models/delete-modal'
import { FaEdit, FaTrash } from 'react-icons/fa';
import { YesNoRendererComponent } from './yes-no-renderer.component'
import { format } from '../services/date.service'
import { MobileLibraryRendererComponent } from './mobile-library-render.component'
import { useConfirm } from '../../hooks/useConfirm'
import { currency } from '../services/common.service'
import InfiniteScroll from 'react-infinite-scroll-component'

const MobileViewTable = ({ onAgentAssignClick, onCargoDriverStatusClick, onCargoDeliveryStatusClick, onCargoTransitStatusClick, onCargoIssueStatusClick, onCargoPickupStatusClick, onCargoOrderStatusClick,
	onSearch = () => { }, dataLength, fetchMoreData, hasMore,
	onGeneratePrintOrderInvoice = () => { }, onShippingStatusClick, onReturnRequestStatusClick, onFullfillmentStatusClick, onPaymentStatusClick, onOrderStatusClick, columnData, rowData, onEdit, additionButtons, onDelete, headingName }: any) => {
	const [deleteData, setDeleteData] = useState({})
	const [visibleTooltip, setVisibleTooltip] = useState<any>({
		row: '',
		column: ''
	});
	const [searchTerm, setSearchTerm] = useState<string>("");
	const [searchColumn, setSearchColumn] = useState<string>("");
	const [searchFilterOperator, setSearchFilterOperator] = useState<string>("");
	const dispatch = useAppDispatch()
	const { confirm, modal } = useConfirm();
	const { getDeleteModal } = useAppSelector(selectCurrent)

	const handleDeleteClose = () => {
		setDeleteData({})
		dispatch(settings.set({ getDeleteModal: 'close' }))
	}
	const handleClickDelete = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to delete ?');
		if (isConfirmed) {
			handleDelete(data)
		}
	};
	const handleDeleteData = () => {
		handleDelete(deleteData)
		handleDeleteClose()
	};

	const filteredFields = _.filter(
		columnData,
		(item) => item.field !== 'Sl' && item.field !== 'Edit'
	)

	const handleEdit = (item: any) => {
		onEdit(item)
	}

	const handleDelete = (item: any) => {
		onDelete(item)
	}
	const filteredSearchField = _.filter(
		columnData,
		(item) => item.search
	)
	const handleTooltipToggle = (rowId: any, columnField: any) => {
		if (visibleTooltip.row === rowId && visibleTooltip.column === columnField) {
			setVisibleTooltip({ row: '', column: '' }); // Close the tooltip if already open
		} else {
			setVisibleTooltip({ row: rowId, column: columnField }); // Open the tooltip for this row and column
		}
	};
	const handleGeneratePrintOrdersInvoice = async (data: any) => {
		onGeneratePrintOrderInvoice(data);
	}
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const tooltipElement = document.getElementById('tooltip');
			if (tooltipElement && !tooltipElement.contains(event.target as Node)) {
				setVisibleTooltip({ row: '', column: '' });
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (


		<div className="py-2 px-6 h-[80vh]">
			<div className="sticky top-0 z-10 bg-white pb-1">
				<div className="flex items-center justify-between w-full my-2">
					{/* Heading Section */}
					<div className="uppercase text-lg font-semibold text-gray-900">
						{headingName ? headingName : ''}
					</div>
					{/* Buttons Section */}
					<div className="flex items-center space-x-2">
						{additionButtons?.length > 0 &&
							additionButtons.map((button: any, index: number) => (
								<button
									key={index}
									onClick={(event) => button.callback(event)}
									type="button"
									className={`flex items-center justify-center bg-blue-700 text-white rounded-md px-3 py-2 
        										${button.disabled ? 'opacity-50 cursor-not-allowed bg-secondary text-gray-400' : ''}`}
									title={button.name === "Add Default" ? "Add Default web pages for all the vendors" : ""}
									disabled={button.disabled}
								>
									{/* Icon */}
									<span className="w-5 h-5 flex items-center justify-center">{button.svg}</span>

									{/* Button Name */}
									<span className="text-sm font-medium whitespace-nowrap">{button.name}</span>
								</button>
							))
						}
					</div>
				</div>
				<div className="flex py-1 items-center relative w-full">
					<input
						type="search"
						name="search"
						onChange={(e) => setSearchTerm(e.target.value)}
						placeholder={`Search ${filteredSearchField[0]?.headerName ? filteredSearchField[0]?.headerName : 'Product'} ...`}
						className="bg-white h-10 w-full px-5 pr-10 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out shadow-sm"
					/>
					<button
						type="button"
						onClick={() => onSearch({
							value: searchTerm
						})}
						className="absolute right-3 top-1/2 transform -translate-y-1/2"
					>
						<svg
							className="h-5 w-5 text-gray-600"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 56.966 56.966"
							fill="currentColor"
						>
							<path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
						</svg>
					</button>
				</div>
			</div>

			<div id="scrollableDiv" className="pb-10 h-[70vh] overflow-y-auto scrollbar-hide">
				<InfiniteScroll
					dataLength={dataLength}
					next={fetchMoreData}
					hasMore={hasMore}
					loader={<h4>Loading...</h4>}
					scrollableTarget="scrollableDiv"
				>
					{rowData?.length !== 0 ?
						<>
							{rowData?.map((row: any, index: any) => (
								<div key={index} className="bg-white shadow-lg rounded-lg mb-4 border border-gray-200">

									<div className={`flex flex-row justify-end items-end ${onEdit || onDelete ? 'border-b-2 px-4 py-2' : ''} -mb-5 space-x-3`}>

										{onEdit &&
											<svg onClick={() => handleEdit(row)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#4a90e2" fill="none">
												<path d="M16.4249 4.60509L17.4149 3.6151C18.2351 2.79497 19.5648 2.79497 20.3849 3.6151C21.205 4.43524 21.205 5.76493 20.3849 6.58507L19.3949 7.57506M16.4249 4.60509L9.76558 11.2644C9.25807 11.772 8.89804 12.4078 8.72397 13.1041L8 16L10.8959 15.276C11.5922 15.102 12.228 14.7419 12.7356 14.2344L19.3949 7.57506M16.4249 4.60509L19.3949 7.57506" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
												<path d="M18.9999 13.5C18.9999 16.7875 18.9999 18.4312 18.092 19.5376C17.9258 19.7401 17.7401 19.9258 17.5375 20.092C16.4312 21 14.7874 21 11.4999 21H11C7.22876 21 5.34316 21 4.17159 19.8284C3.00003 18.6569 3 16.7712 3 13V12.5C3 9.21252 3 7.56879 3.90794 6.46244C4.07417 6.2599 4.2599 6.07417 4.46244 5.90794C5.56879 5 7.21252 5 10.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
											</svg>
										}
										{onDelete &&
											<div className=''>
												<svg onClick={() => handleClickDelete(row)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#d0021b" fill="none">
													<path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
													<path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
													<path d="M9.5 16.5L9.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
													<path d="M14.5 16.5L14.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
												</svg>
												{modal}
											</div>
										}
										{getDeleteModal == 'open' && <DeleteModal onSubmit={handleDeleteData} handleClose={handleDeleteClose} />}
									</div>
									<div className="p-2 m-2 relative">
										{columnData[0]?.isSortLabel ?
											<>
												{filteredFields.map((column: any, index: any) => {
													const dataValue: any = _.property(column.field)(row)
													const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
													return (
														<div key={index} className="flex items-center justify-between mt-4 mb-2">
															<span key={index} className="text-gray-700 font-semibold">{column?.headerName}:</span>
															{column.cellRenderer !== 'yesNoRenderer' && column.isDateValueFormat !== true && column.cellRenderer !== 'imageRenderer' && column.isCurrencyValueFormat !== true && column.cellRenderer !== 'libraryRendererComponent' && column.isAddressFormat !== true && !column.isGeneratedPrintOrders &&
																<span className="text-gray-900 font-medium text-sm truncate pl-4">
																	{dataValue}
																</span>
															}
															{column.isDateValueFormat === true && (
																<span className="text-gray-900 font-medium text-sm pl-2">
																	{format(dataValue)}
																</span>
															)}
															{column.isCurrencyValueFormat === true && (
																<p className="text-gray-900 font-medium text-sm">
																	{currency(dataValue)}
																</p>
															)}
															{column.cellRenderer === 'imageRenderer' && (
																<div className='w-12 h-12'>
																	<img src={dataValue || '/assets/images/product-placeholder.png'} className="w-full h-full object-contain transform transition-transform duration-300 hover:scale-150" />
																</div>
															)}
															{column.cellRenderer === 'yesNoRenderer' && (
																<YesNoRendererComponent
																	cellRenderer={column.cellRenderer}
																	value={dataValue} />
															)}
															{column.isAddressFormat === true && (
																<div className="relative">
																	<span
																		className="font-semibold truncate text-gray-900"
																		title={address?.length > 15 ? address : ''}
																		onClick={() => handleTooltipToggle(row.Id, column.field)}
																	>
																		{address?.length > 15 ? `${address.substring(0, 15)}...` : address}
																	</span>
																	{visibleTooltip.row === row.Id && visibleTooltip.column === column.field && (
																		<div
																			id="tooltip"
																			onClick={() => setVisibleTooltip({ row: '', column: '' })}
																			className="fixed z-50 bg-gray-900 text-white text-sm rounded pr-10 pl-3 py-3 shadow-lg top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-screen"
																		>
																			{address}
																		</div>
																	)}
																</div>
															)}
															{column.cellRenderer === 'libraryRendererComponent' &&
																<MobileLibraryRendererComponent
																	cellRenderer={column.cellRenderer}
																	cellRendererParams={column.cellRendererParams}
																	data={column}
																	dataId={row}
																	onCargoDriverStatusClick={onCargoDriverStatusClick}
																	onCargoDeliveryStatusClick={onCargoDeliveryStatusClick}
																	onCargoTransitStatusClick={onCargoTransitStatusClick}
																	onCargoIssueStatusClick={onCargoIssueStatusClick}
																	onCargoPickupStatusClick={onCargoPickupStatusClick}
																	onCargoOrderStatusClick={onCargoOrderStatusClick}
																	onAgentAssignClick={onAgentAssignClick}
																	onOrderStatusClick={onOrderStatusClick}
																	onPaymentStatusClick={onPaymentStatusClick}
																	onFullfillmentStatusSubmit={onFullfillmentStatusClick}
																	onReturnRequestStatusClick={onReturnRequestStatusClick}
																	onShippingStatusClick={onShippingStatusClick}
																	value={dataValue}
																/>
															}
															{column.isGeneratedPrintOrders && (
																// console.log('print', dataValue),
																<div className='flex items-center cursor-pointer  text-blue-800 ' onClick={() => { handleGeneratePrintOrdersInvoice(row) }} title={`Print - Invoice No: ${dataValue}`}>
																	{dataValue}
																	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
																		<text x="4" y="10" font-family="Arial" font-size="10" fill="red">PDF</text>
																	</svg>
																</div>
															)}
														</div>
													)
												})}
											</>
											:
											<>
												{filteredFields.map((column: any, index: any) => {
													const dataValue: any = _.property(column.field)(row)
													const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
													return (
														<div className="flex items-center justify-between mt-5 mb-2">
															<span key={index} className="text-gray-700 font-bold">{column?.headerName}:</span>
															{column.cellRenderer !== 'yesNoRenderer' && column.isDateValueFormat !== true && column.cellRenderer !== 'imageRenderer' && column.isCurrencyValueFormat !== true && column.cellRenderer !== 'libraryRendererComponent' && column.isAddressFormat !== true && !column.isGeneratedPrintOrders &&
																<span className="text-gray-900 font-medium text-sm truncate pl-4">
																	{dataValue}
																</span>
															}
															{column.isDateValueFormat === true && (
																<span className="text-gray-900 font-medium text-sm pl-2">
																	{format(dataValue)}
																</span>
															)}
															{column.isCurrencyValueFormat === true && (
																<p className="text-gray-900 font-medium text-sm">
																	{currency(dataValue)}
																</p>
															)}
															{column.cellRenderer === 'imageRenderer' && (
																<div className='w-12 h-12'>
																	<img src={dataValue || '/assets/images/product-placeholder.png'} className="w-full h-full object-contain transform transition-transform duration-300 hover:scale-150" />
																</div>
															)}
															{column.cellRenderer === 'yesNoRenderer' && (
																<YesNoRendererComponent
																	cellRenderer={column.cellRenderer}
																	value={dataValue} />
															)}
															{column.isGeneratedPrintOrders && (
																// console.log('print', dataValue),
																<div className='flex items-center cursor-pointer  text-blue-800 ' onClick={() => { handleGeneratePrintOrdersInvoice(row) }} title={`Print - Invoice No: ${dataValue}`}>
																	{dataValue}
																	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
																		<text x="4" y="10" font-family="Arial" font-size="10" fill="red">PDF</text>
																	</svg>
																</div>
															)}
															{column.isAddressFormat === true && (
																<div className="relative">
																	<span
																		className="font-semibold truncate text-gray-900"
																		title={address?.length > 15 ? address : ''}
																		onClick={() => handleTooltipToggle(row.Id, column.field)}
																	>
																		{address?.length > 15 ? `${address.substring(0, 15)}...` : address}
																	</span>
																	{visibleTooltip.row === row.Id && visibleTooltip.column === column.field && (
																		<div
																			id="tooltip"
																			onClick={() => setVisibleTooltip({ row: '', column: '' })}
																			className="fixed z-50 bg-gray-900 text-white text-sm rounded pr-10 pl-3 py-3 shadow-lg top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-screen"
																		>
																			{address}
																		</div>
																	)}
																</div>
															)}
															{column.cellRenderer === 'libraryRendererComponent' &&
																<MobileLibraryRendererComponent
																	cellRenderer={column.cellRenderer}
																	cellRendererParams={column.cellRendererParams}
																	data={column}
																	dataId={row}
																	onCargoDriverStatusClick={onCargoDriverStatusClick}
																	onCargoDeliveryStatusClick={onCargoDeliveryStatusClick}
																	onCargoTransitStatusClick={onCargoTransitStatusClick}
																	onCargoIssueStatusClick={onCargoIssueStatusClick}
																	onCargoPickupStatusClick={onCargoPickupStatusClick}
																	onCargoOrderStatusClick={onCargoOrderStatusClick}
																	onAgentAssignClick={onAgentAssignClick}
																	onOrderStatusClick={onOrderStatusClick}
																	onPaymentStatusClick={onPaymentStatusClick}
																	onFullfillmentStatusSubmit={onFullfillmentStatusClick}
																	onReturnRequestStatusClick={onReturnRequestStatusClick}
																	onShippingStatusClick={onShippingStatusClick}
																	value={dataValue}
																/>
															}
														</div>
													)
												})}</>}
									</div>
								</div>))}</>

						:
						<div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
				</InfiniteScroll>
			</div>
		</div>






	)
}

export default MobileViewTable